// extracted by mini-css-extract-plugin
export default {"search":"Search_search__k02nK","path":"Search_path__J61bp","command":"Search_command__HvcEw"};